import AutoSelectDetailChart from './AutoSelectDetailChart';

export default AutoSelectDetailChart;
